import React from 'react';

export const CheckboxIcon: React.FC<{
  borderClassName: string;
  checkClassName: string;
}> = (props) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect className={props.borderClassName} x='0.5' y='0.5' width='15' height='15' />
    <path className={props.checkClassName} d='M3 8L7 11L13 4' strokeWidth='2' />
  </svg>
);
